import { navigate } from 'gatsby';
import useRecaptcha from 'hooks/useReCAPTCHA';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

import helpers from 'utils/helpers';
import routing from 'utils/routing';
import trackings from 'utils/trackings';

import apis from 'services/apis';
import entities from 'services/entities';

const useHero = ({ segmentAccount, eventTracking, scrollRef }) => {
  const { getRecaptcha } = useRecaptcha();
  const [isRequestLoading, setIsRequestLoading] = useState(false);

  const { control, formState, getValues } = useForm({
    mode: 'onChange',
    defaultValues: { document_number: '___.___.___-__' },
  });

  const formMethods = {
    control,
    formState,
    isValid: formState.isValid,
  };

  const onCreateProposal = async (event, { getValues }) => {
    event.preventDefault();
    if (isRequestLoading) return;

    setIsRequestLoading(true);

    const { ga4Event, pageInteraction } = trackings;

    pageInteraction({
      pageName: `${eventTracking}-lp`,
      eventName: `${eventTracking}-lp_button-cpf-fixed`,
    });

    const token = await getRecaptcha();
    const stepName = 'cpf';

    const payload = {
      ...getValues(),
      recaptchaToken: token,
      intentSegmentAccount: segmentAccount,
    };

    const requestResponse = await apis.proposal.createLead({
      stepName,
      payload,
    });

    if (requestResponse.error) {
      setIsRequestLoading(false);
      return;
    }

    const handledData = entities.response.proposal({
      stepName,
      data: requestResponse.data,
    });

    const nextStep = handledData.nextStep;
    const nextPage = handledData.nextPage;
    const enrichedLeadToken = handledData.enrichedLeadToken;
    const enrichedLeadTokenExp = handledData.enrichedLeadTokenExp;

    await helpers.auth.storeEnrichedLeadToken({
      enrichedLeadToken,
      enrichedLeadTokenExp,
    });

    ga4Event({
      eventName: 'click',
      customPath: `lp-cpf/${segmentAccount}`,
      detail: 'botao-abra-sua-conta',
    });

    const nextPagePath = routing.handleStepPath(nextPage ?? nextStep);
    navigate(nextPagePath);
  };

  const scrollTo = () => {
    helpers.scroll.scrollToElement(scrollRef, -100);
  };

  return {
    onCreateProposal,
    isRequestLoading,
    scrollTo,
    formMethods,
    getValues,
  };
};

export default useHero;
